import React, { useState } from "react";
import { Modal, Button } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import useAuthorizedContext from "hooks/useAuthorizedContext";

import SimpleButton, {
  definedButtonTypes,
} from "../../atoms/Buttons/SimpleButton/SimpleButton";
import { EntityForm, isCompany, isOrganization } from "../../../api/index.d";
import useTypeTableContext, {
  definedTableActions,
} from "../../../hooks/useTypeTableContext";
import { updateOrganizations } from "../../../api/OrganizationsApi";
import EntityPostModel from "../../../models/EntityPostModel";
import { updateCompanies } from "../../../api/CompaniesApi";

interface DeleteModalProps {
  data: EntityForm;
}

const DeleteHomepageModal: React.FC<DeleteModalProps> = ({ data }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const typeTableContext = useTypeTableContext();
  const { token } = useAuthorizedContext();

  const deleteFn = async () => {
    try {
      const act = definedTableActions.update;
      setLoading(true);
      const dat = await EntityPostModel(data);
      const newData: EntityForm = {
        ...dat,
        templateSite: null,
      };
      const idToken = await token();
      if (isOrganization(newData)) {
        await updateOrganizations(idToken, newData);
      } else if (isCompany(newData)) {
        await updateCompanies(idToken, newData);
      } else {
        throw new Error("unsupported type given to homepage delete modal");
      }
      toast.success("Dzēsts veiksmīgi");
      if (typeTableContext) typeTableContext.updateTableEntry(newData, act);
    } catch {
      toast.error("Dzēšot radās kļūda! Mēģini vēlreiz!");
    } finally {
      setLoading(false);
      setOpen(false);
    }
  };

  return (
    <Modal
      size="mini"
      open={open}
      trigger={
        <Button
          size="mini"
          icon="trash alternate outline"
          onClick={() => setOpen(true)}
        />
      }
      closeOnEscape={false}
      closeOnDimmerClick={false}
    >
      <Modal.Header>Tiešām dzēst?</Modal.Header>
      <Modal.Content>
        <p>{`Tu gatavojies dzēst organizācijas "${data.title}" mājaslapu.`}</p>
        <p>
          Dzēšot mājaslapu, tiks neatgriezeniski dzēsts viss tās saturs. Pirms
          turpināt, pārliecinies, ka esi saglabājis tajā atrodamo informāciju.
        </p>
      </Modal.Content>
      <Modal.Actions>
        <SimpleButton
          variant={definedButtonTypes.secondary}
          onClick={() => setOpen(false)}
          disabled={loading}
        >
          {t("Forms.Modal.Cancel")}
        </SimpleButton>
        <SimpleButton
          variant={definedButtonTypes.primary}
          onClick={deleteFn}
          loading={loading}
        >
          {t("Forms.Modal.Delete")}
        </SimpleButton>
      </Modal.Actions>
    </Modal>
  );
};

export default DeleteHomepageModal;
